import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <section className="privacy-hero">
        <h1>Privacy Policy For DataUpPro</h1>
        <p>Your data is protected and your privacy is ensured.</p>
      </section>

      <section className="privacy-content">
        <h2>Google Privacy Policy</h2>
        <div className="privacy-points">
          <div className="privacy-point">
            <h3>Collected Information</h3>
            <p>Third-party services like Google AdSense may collect data for ad personalization and analytics.</p>
          </div>
          <div className="privacy-point">
            <h3>Google AdSense and Cookies</h3>
            <p>This site usesGoogle AdSense to display advertisements. Google may use cookies, web 
              beacons, and similar tracking technologies to serve ads based on your previous interactions with this website and other sites.</p>
            
            <h4>How Google Uses Your Data</h4>
            <ol>
              <li>
                Google may collect data about your browsing behavior to deliver personalized ads.
              </li>
              <li>
                These ads are based on your interests, location, and browsing history.
              </li>
              <li>
                Google’s use of advertising cookies enables it and its partners to serve ads based on visits to our site and other sites on the Internet.
              </li>
              
            </ol>
            <p>For more information on how Google uses your data, please refer to the <a href="https://policies.google.com/privacy?hl=en">Google Privacy Policy</a>.</p>
          </div>

          <div className="privacy-point">
            <h3>How to Opt Out of and manage Google Ads</h3>
            <p>You can disable personalized ads by:</p>
            <ol>
              <li>
                <a href='https://adssettings.google.com/'>Visiting Google Ad Settings.</a>
                
              </li>
              <li>Using browser settings to block cookies.
              </li>
              <li>Installing Google’s opt-out extension.</li>
            </ol>
          </div>

          <div className="privacy-point">
            <h3>Data Protection and Compliance</h3>
            <p>DataUpPro complies with the General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA).</p>
            <h4>For EU Users:</h4>
            <ol>
              <li>
                You have the right to access, delete, or restrict processing of your data.
                
              </li>
              <li>You can withdraw consent for personalized ads anytime.</li>
            </ol>
            <h5>For California Users</h5>
            <ol>
              <li>You have the right to opt out of the sale of your personal data.</li>
              <li><p>To exercise your rights visit Google's Do Not Sale Page.</p></li>
            </ol>
          </div>
          
          <div className="privacy-point">
            <h3>Changes to This Policy</h3>
            <p>This privacy policy may be updated periodically. Please review it regularly for changes.</p>
          </div>
          
        </div>
      </section>

      <section className="privacy-content">
        <h2>How Data Is Handled</h2>
        <div className="privacy-points">
          <div className="privacy-point">
            <h3>Data Storage</h3>
            <p>All data is stored locally on your device. None of your data is stored or saved on servers.</p>
          </div>
          <div className="privacy-point">
            <h3>Temporary Use</h3>
            <p>Your data is only used temporarily during the processing phase and is never retained after the session ends.</p>
          </div>
          <div className="privacy-point">
            <h3>No Third-Party Sharing</h3>
            <p>Your data is not shared with any third party sources. Your information remains confidential.</p>
          </div>
          
        </div>
      </section>
    </div>
  );
};

export default Privacy;